import React from 'react';
import { Link } from 'react-router-dom';
import { CheckBox } from 'devextreme-react/check-box';
import { DateBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import { Popup } from 'devextreme-react/popup';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import DataGrid, { Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format } from 'devextreme-react/data-grid';
import Box, { Item } from 'devextreme-react/box';
import { Button } from 'devextreme-react';
import { TextBox } from 'devextreme-react';

export default class ClientDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newLogin: this.props.location.state.data.login,
            newPhone: this.props.location.state.data.phone,
            newEMail: this.props.location.state.data.eMail,
            newManagerName: this.props.location.state.data.managerName,
            isActive: this.props.location.state.data.isActive,
            newPassword: 'Вы можете сбросить пароль пользователя',
            selectedPortfolio: null,
            selectedPortfolioName: 'Все портфели',
            isHideLabel: 'Доступно для индивидуальных портфелей',
            isHideButtonText: 'Действие',
            isHideDisabled: true,
            clientData: this.props.location.state.data,
            portfolios: [],
            allPortfolioCheckBox: true,
            enablePortfolioControl: true,
            loginReadOnly: true,
            passwordReadOnly: true,
            phoneReadOnly: true,
            emailReadOnly: true,

            confirmPasswordVisible: false,
            cancelButtonVisible: false,

            loginButtonText: 'Изменить логин',
            phoneButtonText: 'Изменить телефон',
            emailButtonText: 'Изменить e-mail',
            activeButtonText: this.props.location.state.data.isActive == false ? "Активировать" : "Заблокировать",
            activeText: this.props.location.state.data.isActive == false ? "Заблокирован" : "Активен",

            loginButtonState: 'default',
            phoneButtonState: 'default',
            emailButtonState: 'default'
        };

        this.refreshData = this.refreshData.bind(this);

        this.onLoginChanged = this.onLoginChanged.bind(this);
        this.onPhoneChanged = this.onPhoneChanged.bind(this);
        this.onEMailChanged = this.onEMailChanged.bind(this);

        this.onPortfolioSelectionChanged = this.onPortfolioSelectionChanged.bind(this);
        this.updatePortfolio = this.updatePortfolio.bind(this);
        this.updateClientInfo = this.updateClientInfo.bind(this);
        this.onHidePortfolioChanged = this.onHidePortfolioChanged.bind(this);
        this.allPortfolioChanged = this.allPortfolioChanged.bind(this);

        this.onChangeLoginClick = this.onChangeLoginClick.bind(this);
        this.onChangePasswordClick = this.onChangePasswordClick.bind(this);
        this.onChangePhoneClick = this.onChangePhoneClick.bind(this);
        this.onChangeEmailClick = this.onChangeEmailClick.bind(this);
        this.onActivateClick = this.onActivateClick.bind(this);
        this.onConfirmPasswordClick = this.onConfirmPasswordClick.bind(this);
        this.onCancelPasswordClick = this.onCancelPasswordClick.bind(this);
        this.onChangePortfolioVisibleClick = this.onChangePortfolioVisibleClick.bind(this);

        this.hideConfirmPassword = this.hideConfirmPassword.bind(this);
        this.showConfirmPassword = this.showConfirmPassword.bind(this);
        this.changeLogin = this.changeLogin.bind(this);
        this.changePhone = this.changePhone.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.activateUser = this.activateUser.bind(this);
        this.blockUser = this.blockUser.bind(this);

        this.cancelEdit = this.cancelEdit.bind(this);
        this.checkCancelButton = this.checkCancelButton.bind(this);

        this.oldLogin = this.props.location.state.data.login;
        this.oldPhone = this.props.location.state.data.phone;
        this.oldEmail = this.props.location.state.data.eMail;

        this.refreshData();
    }

    refreshData() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/clientDetails', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(this.state.clientData)
        }).then(response => response.json())
            .then(data => {                
                this.setState({ portfolios: data.portfolios, allPortfolioCheckBox: false, selectedPortfolio: null, selectedPortfolioName: 'Портфель не выбран', enablePortfolioControl: true, isHideButtonText: 'Действие', isHideLabel: 'Доступно для индивидуальных портфелей', isHideDisabled: true });
            });
    }

    onChangePortfolioVisibleClick() {
        var operationData = {
            objectId: this.state.selectedPortfolio.portfolioId,
            flag: this.state.selectedPortfolio.isHide == true ? false : true
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/portfolioVisible', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(operationData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                if (data.isSucceeded == true) {
                    this.refreshData();
                }
            });
    }

    hideConfirmPassword() {
        this.setState({ confirmPasswordVisible: false });
    }

    showConfirmPassword() {
        this.setState({ confirmPasswordVisible: true });
    }

    onConfirmPasswordClick() {
        this.hideConfirmPassword();
        this.changePassword();
    }

    onCancelPasswordClick() {
        this.hideConfirmPassword();
    }

    cancelEdit() {
        this.setState({
            phoneButtonText: 'Изменить телефон', phoneReadOnly: true, phoneButtonState: 'default', newPhone: this.oldPhone,
            emailButtonText: 'Изменить e-mail', emailReadOnly: true, emailButtonState: 'default', newEMail: this.oldEmail,
            loginButtonText: 'Изменить логин', loginReadOnly: true, loginButtonState: 'default', newLogin: this.oldLogin,
            cancelButtonVisible: false
        });
    }

    onActivateClick() {
        if (this.state.isActive == false) {
            this.activateUser();
        }
        else {
            this.blockUser();
        }
    }

    activateUser() {
        var clientData = {
            userId: this.state.clientData.userId
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/activateUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                if (data.isSucceeded == true) {
                    this.setState({ activeButtonText: "Заблокировать", activeText: "Активен", isActive: true });
                }
            });
    }

    blockUser() {
        var clientData = {
            userId: this.state.clientData.userId
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/blockUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                if (data.isSucceeded == true) {
                    this.setState({ activeButtonText: "Активировать", activeText: "Заблокирован", isActive: false });
                }
            });
    }

    checkCancelButton() {
        if (this.state.loginReadOnly == false || this.state.emailReadOnly == false || this.state.phoneReadOnly == false) {
            this.setState({ cancelButtonVisible: true });
        }
        else {
            this.setState({ cancelButtonVisible: false });
        }
    }

    onChangePhoneClick() {
        if (this.state.phoneReadOnly == true) {
            this.oldPhone = this.state.newPhone;
            this.setState({ phoneButtonText: 'Применить', phoneReadOnly: false, phoneButtonState: 'danger' });
            this.checkCancelButton();
        }
        else {
            this.changePhone();
        }
    }

    changePhone() {
        var clientData = {
            userId: this.state.clientData.userId,
            phone: this.state.newPhone
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/setPhone', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ phoneButtonText: 'Изменить телефон', phoneReadOnly: true, phoneButtonState: 'default' });
                if (data.isSucceeded == false) {
                    this.setState({ newPhone: this.state.clientData.phone });
                    this.oldPhone = this.state.clientData.phone;
                }
                else {
                    this.oldPhone = this.state.newPhone;
                }
                this.checkCancelButton();
            });
    }

    onChangeEmailClick() {
        if (this.state.emailReadOnly == true) {
            this.oldEmail = this.state.newEMail;
            this.setState({ emailButtonText: 'Применить', emailReadOnly: false, emailButtonState: 'danger' });
            this.checkCancelButton();
        }
        else {
            this.changeEmail();
        }
    }

    changeEmail() {
        var clientData = {
            userId: this.state.clientData.userId,
            eMail: this.state.newEMail
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/setEMail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ emailButtonText: 'Изменить e-mail', emailReadOnly: true, emailButtonState: 'default' });
                this.checkCancelButton();
                if (data.isSucceeded == false) {
                    this.setState({ newEMail: this.state.clientData.eMail });
                }
                else {
                    this.oldEmail = this.state.newEMail;
                }
            });
    }

    onChangeLoginClick() {
        if (this.state.loginReadOnly == true) {
            this.oldLogin = this.state.newLogin;
            this.setState({ loginButtonText: 'Применить', loginReadOnly: false, loginButtonState: 'danger' });
            this.checkCancelButton();
        }
        else {
            this.changeLogin();
        }
    }

    changeLogin() {
        var clientData = {
            userId: this.state.clientData.userId,
            login: this.state.newLogin
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/setLogin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ loginButtonText: 'Изменить логин', loginReadOnly: true, loginButtonState: 'default' });
                if (data.isSucceeded == false) {
                    this.setState({ newLogin: this.state.clientData.login });
                } else {
                    this.oldLogin = this.state.newLogin;
                }
                this.checkCancelButton();
            });
    }

    onChangePasswordClick() {
        this.showConfirmPassword();
    }

    changePassword() {
        var randomstring = Math.random().toString(36).slice(-8);

        var passwordData = {
            userId: this.state.clientData.userId,
            newPassword: randomstring
        };

        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/ResetPassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(passwordData)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                if (data.isSucceeded == true) {
                    this.setState({ newPassword: randomstring });
                }
            });
    }

    allPortfolioChanged(e) {
        if (e.value == true) {
            this.setState({ allPortfolioCheckBox: e.value, selectedPortfolio: null, selectedPortfolioName: 'Все портфели', enablePortfolioControl: true, isHideButtonText: 'Действие', isHideLabel: 'Доступно для индивидуальных портфелей', isHideDisabled: true });
        }
        else {
            this.setState({ allPortfolioCheckBox: e.value, selectedPortfolio: null, selectedPortfolioName: 'Портфель не выбран', enablePortfolioControl: false, isHideButtonText: 'Действие', isHideLabel: 'Доступно для индивидуальных портфелей', isHideDisabled: true });
        }
    }

    onLoginChanged(e) {
        this.setState({ newLogin: e.value });
    }

    onPhoneChanged(e) {
        this.setState({ newPhone: e.value });
    }

    onEMailChanged(e) {
        this.setState({ newEMail: e.value });
    }    

    updatePortfolio() {
        var clientPortfolioInfo = {
            portfolioId: this.state.selectedPortfolio.portfolioId,
            name: this.state.selectedPortfolioName
        };

        var tokenKey = "accessToken";

        this.setState({ enablePortfolioControl: false });

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/updatePortfolio', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clientPortfolioInfo)
        }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ enablePortfolioControl: true });
                this.refreshData();
            });
    }

    updateClientInfo() {
        var clientPortfolioInfo = {
            binClientId: this.state.clientData.binClientId
        };

        var tokenKey = "accessToken";

        this.setState({ enablePortfolioControl: false });

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/updateClientInfo', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(clientPortfolioInfo)
            }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ enablePortfolioControl: true });
                this.refreshData();
            });
    }

    onPortfolioSelectionChanged(selectedRowsData) {
        const data = selectedRowsData.selectedRowsData[0];
        if (selectedRowsData.selectedRowsData.length > 0) {
            var hideLabel = data.isHide == true ? "Портфель недоступен пользователю" : "Портфель доступен пользователю";
            var hideButtonText = data.isHide == true ? "Показать" : "Скрыть";
            this.setState({ selectedPortfolio: data, selectedPortfolioName: data.name, allPortfolioCheckBox: false, enablePortfolioControl: true, isHideButtonText: hideButtonText, isHideLabel: hideLabel, isHideDisabled: false });
        } else {
            this.setState({ allPortfolioCheckBox: e.value, selectedPortfolio: null, selectedPortfolioName: 'Портфель не выбран', enablePortfolioControl: false, isHideButtonText: 'Действие', isHideLabel: 'Доступно для индивидуальных портфелей', isHideDisabled: true });
        }
    }

    onHidePortfolioChanged(args) {
        this.setState({
            hideSelectedPortfolio: args.value
        });
    }

    render() {

        var fullName = this.state.clientData.lastName + " " + this.state.clientData.firstName + " " + this.state.clientData.patronymic;

        return (
            <div>
                <Grid fluid className="positionGrid">
                    <Row>
                        <Col lg={6}>
                            <Panel header={fullName}>
                                <Grid fluid className="positionInfo">
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-user"></span> Логин: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.newLogin} readOnly={this.state.loginReadOnly} placeholder="Задайте логин" className="detailTextBox"
                                                        onValueChanged={this.onLoginChanged} valueChangeEvent={'keyup'}
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={this.state.loginButtonText}
                                                            width={200}
                                                            type={this.state.loginButtonState}
                                                            onClick={this.onChangeLoginClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-tel"></span> Телефон для подтверждения: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.newPhone} readOnly={this.state.phoneReadOnly} mask={'+0 (000) 000-0000'} placeholder="Телефон" className="detailTextBox"
                                                        onValueChanged={this.onPhoneChanged} valueChangeEvent={'keyup'}
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={this.state.phoneButtonText}
                                                            width={200}
                                                            type={this.state.phoneButtonState}
                                                            onClick={this.onChangePhoneClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-message"></span> e-mail: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.newEMail} readOnly={this.state.emailReadOnly} placeholder="e-mail" className="detailTextBox"
                                                        onValueChanged={this.onEMailChanged} valueChangeEvent={'keyup'}
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={this.state.emailButtonText}
                                                            width={200}
                                                            type={this.state.emailButtonState}
                                                            onClick={this.onChangeEmailClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-key"></span> Пароль: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.newPassword} placeholder="Пароль" readOnly={this.state.passwordReadOnly} className="detailTextBox"
                                                        onValueChanged={this.onLoginChanged}
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={'Сбросить пароль'}
                                                            width={200}
                                                            type={'default'}
                                                            onClick={this.onChangePasswordClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-group"></span> Менеджер: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.newManagerName} readOnly={true} placeholder="" className="detailTextBox"
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div width={200} />
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={0}
                                                    baseSize={160}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-check"></span> Статус: </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={1}>
                                                    <TextBox value={this.state.activeText} readOnly={true} placeholder="" className="detailTextBox"
                                                    />
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={this.state.activeButtonText}
                                                            width={200}
                                                            type={'danger'}
                                                            onClick={this.onActivateClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    
                                    <Row><Col lg={12}>
                                        <div className="centerContent">
                                            <Button
                                                visible={this.state.cancelButtonVisible}
                                                text={'Отменить'}
                                                width={200}
                                                type={'default'}
                                                onClick={this.cancelEdit}
                                            />
                                        </div>
                                    </Col></Row>
                                </Grid>
                            </Panel>
                        </Col>
                        <Col lg={6}>
                            <Panel header={this.state.selectedPortfolioName}>
                                <Grid fluid className="positionInfo">
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={1}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-clock"></span> Данные за весь период существования портфеля (до Т-2) </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={'Обновить'}
                                                            disabled={!this.state.enablePortfolioControl}
                                                            width={200}
                                                            type={'default'}
                                                            onClick={this.updatePortfolio}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={1}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-refresh"></span> Только новые данные (до T-1) </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={'Обновить'}
                                                            disabled={!this.state.enablePortfolioControl}
                                                            width={200}
                                                            type={'default'}
                                                            onClick={this.updatePortfolio}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={1}>
                                                    <table width="100%">
                                                        <tr>
                                                            <td>
                                                                <DateBox value={this.state.fromDate} min={this.minDate} max={this.maxDate} onValueChanged={this.onFromDateChanged} width={"auto"} id="periodFrom"></DateBox>
                                                            </td>
                                                            <td>
                                                                <DateBox value={this.state.toDate} min={this.minDate} max={this.maxDate} onValueChanged={this.onToDateChanged} width={"auto"} id="periodTo"></DateBox>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={'Обновить'}
                                                            disabled={!this.state.enablePortfolioControl}
                                                            width={200}
                                                            type={'default'}
                                                            onClick={this.updatePortfolio}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Box className="detailLine"
                                                direction={'row'}
                                                width={'100%'}
                                                height={'auto'}>
                                                <Item
                                                    ratio={1}>
                                                    <div className="testClass">
                                                        <div className="verticalContent"><span className="dx-icon-pin"></span> {this.state.isHideLabel} </div>
                                                    </div>
                                                </Item>
                                                <Item
                                                    ratio={0}
                                                    baseSize={220}>
                                                    <div className="centerContent">
                                                        <Button
                                                            text={this.state.isHideButtonText}
                                                            disabled={this.state.isHideDisabled}
                                                            width={200}
                                                            type={'default'}
                                                            onClick={this.onChangePortfolioVisibleClick}
                                                        />
                                                    </div>
                                                </Item>
                                            </Box>
                                        </Col>
                                    </Row>
                                </Grid>
                            </Panel>
                            <Row>
                                <Col lg={12}>
                                    <CheckBox value={this.state.allPortfolioCheckBox} onValueChanged={this.allPortfolioChanged} text={'Для всех портфелей'}></CheckBox>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="helpBlock">
                                        <span className="helpIcon dx-icon-tips"></span>
                                        <div className="helpText">
                                            Вы можете выбрать один портфель из списка ниже или установить флажок "Для всех портфелей" чтобы произвести обновление данных в индивидуальном или групповом режиме.
                                            </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Panel header="Портфели">
                                <DataGrid
                                    dataSource={this.state.portfolios}
                                    allowColumnReordering={true}
                                    onSelectionChanged={this.onPortfolioSelectionChanged}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    hoverStateEnabled={true}
                                    selection={{ mode: 'single' }}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={false}>
                                    <Column
                                        dataField={'name'}
                                        caption={'Номер'}>
                                    </Column>
                                    <Column
                                        dataField={'isHide'}
                                        caption={'Скрывать'}>
                                    </Column>
                                    <Column
                                        dataField={'product'}
                                        caption={'Продукт'}>
                                    </Column>
                                    <Column
                                        dataField={'strategy'}
                                        caption={'Стратегия'}>
                                    </Column>
                                    <Column
                                        dataField={'riskProfile'}
                                        caption={'Риск-профиль'}>
                                    </Column>
                                    <Column
                                        dataField={'openDate'}
                                        caption={'Дата открытия'}
                                        dataType={'date'}>
                                    </Column>
                                    <Column
                                        dataField={'closeDate'}
                                        caption={'Дата закрытия'}
                                        dataType={'date'}>
                                    </Column>
                                    <Column
                                        dataField={'dataFrom'}
                                        caption={'Данные с'}
                                        dataType={'date'}>
                                    </Column>
                                    <Column
                                        dataField={'dataTo'}
                                        caption={'Данные по'}
                                        dataType={'date'}>
                                    </Column>
                                </DataGrid>
                            </Panel>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Button
                                text={'Обновить список'}
                                width={200}
                                type={'default'}
                                onClick={this.updateClientInfo}
                            />                        
                            <div className="helpBlock">
                                <span className="helpIcon dx-icon-tips"></span>
                                <div className="helpText">
                                    При нажатии кнопки "Обновить список" список портфелей будет синхронизирован с соответствующим справочником Бинокля. Новые портфели будут добавлены в список, данные по уже представленным портфелям не потеряются.
                                            </div>
                            </div>
                        </Col>

                    </Row>
                </Grid>
                <Popup
                    className={'popup'}
                    visible={this.state.confirmPasswordVisible}
                    onHiding={this.hideConfirmPassword}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Подтверждение операции'}
                    width={400}
                    height={'auto'}
                >
                    <div>
                        <Grid fluid>
                            <Row>
                                <Col lg={12}>
                                    <div>Сгенерировать новый случайный пароль для пользователя?</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="confirmButtons">
                                        <Button
                                            className="confirmButton"
                                            text={'Да'}
                                            type={'danger'}
                                            width={120}
                                            onClick={this.onConfirmPasswordClick}
                                        />
                                        <Button
                                            className="confirmButton"
                                            text={'Отмена'}
                                            type={'default'}
                                            width={120}
                                            onClick={this.onCancelPasswordClick}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Popup>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./App/containers/users/clientDetail.jsx